import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import TimelineTools from './TimelineTools';
import {
  DateBadge,
  EventImage,
  EventInfoCard,
  GeneralInfo,
  ProgessInfo,
  Location,
  TimeInfo,
  Status,
  People,
} from 'components/timeline/TimelineInfo';

import { useEvent } from 'components/context/EventContext';

const TimelineEventInfo: FC = () => {
  const { t } = useTranslation();

  const { isEventGuest } = useEvent();

  return (
    <EventInfoCard>
      <EventImage placeholder={t('addEventPhoto')} />
      <GeneralInfo>
        {isEventGuest ? null : <ProgessInfo />}
        <Location />
        <TimeInfo />
        <Status />
        <People />
      </GeneralInfo>
      <DateBadge />
      <TimelineTools />
    </EventInfoCard>
  );
};

export default TimelineEventInfo;
